import rawPosts from './posts.json';
import { withAssetBase } from '../utils/assetBase';

const STATIC_ASSET_FILENAMES = [
  '24-01-SupportedInstitutionsDE.xlsx',
  '24-01-SupportedInstitutionsForeign.xlsx',
  'logo_notagline.png',
  'logo_notagline_dark.png',
];

const replaceStaticLinks = (body) => {
  if (!body) return body;
  return STATIC_ASSET_FILENAMES.reduce((acc, filename) => {
    const pattern = new RegExp(`\\(/?${filename.replace(/\./g, '\\.')}\\)`, 'g');
    return acc.replace(pattern, `(${withAssetBase(filename)})`);
  }, body);
};

const posts = rawPosts.map((post) => ({
  ...post,
  en: {
    ...post.en,
    body: replaceStaticLinks(post.en.body),
  },
  de: {
    ...post.de,
    body: replaceStaticLinks(post.de.body),
  },
}));

export default posts;
